import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getCommercialBodyType } from './commercialThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearCommercialKey } from '../../sell/sellKeys';
const SLICE_NAME = 'bodyType';

export const bodyTypeSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearCommercialBodyType(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCommercialBodyType }).addCase(
            clearCommercialKey,
            () => commonInitialState,
        );
    },
});

export const { clearCommercialBodyType } = bodyTypeSlice.actions;

export const bodyType = bodyTypeSlice.reducer;
